import { Store } from 'pullstate';
import ConfigStore from 'lib/stores/configStore';
import ValidationTypes from 'lib/constants/validationTypes';

const ValidationStore = new Store({});

const getActualName = (name, type) => {
  if (type === ValidationTypes.PHONE || type === ValidationTypes.EMAIL) {
    return name.split('.').slice(-2).join('_');
  }

  return name.split('.').slice(-1).pop();
};

export const addValidation = (state, name, valid, error, type) => {
  const page = ConfigStore.currentState.currentPage;
  const actualName = getActualName(name, type);
  const current = state[page][actualName];
  let errors = current ? current.errors : [];

  if (valid) errors = [];
  if (!valid && !errors.includes(error)) errors.push(error);

  state[page][actualName] = { valid, errors };
};

export const removeValidation = (state, name, type) => {
  const page = ConfigStore.currentState.currentPage;
  const actualName = getActualName(name, type);

  if (typeof state[page][actualName] === 'undefined') return;

  delete state[page][actualName];
};

export default ValidationStore;
